export const server = "https://ohkoil-backend.vercel.app/api/v2";

//  http://localhost:8000/api/v2

// https://ohkoil-backend.vercel.app/api/v2



